import { NAMESPACE } from '../../lib/constants';
import { types } from './types';
export const initialState = {
    experiments: {},
};
export const reducer = (state = initialState, action) => {
    switch (action.type) {
        case types.FETCH_EXPERIMENT.REQUEST: {
            const { payload: { projectId }, } = action;
            return {
                ...state,
                experiments: {
                    ...state.experiments,
                    [projectId]: { isLoading: true },
                },
            };
        }
        case types.FETCH_EXPERIMENT.SUCCESS: {
            const { payload } = action;
            return {
                ...state,
                experiments: {
                    ...state.experiments,
                    [payload.projectId]: {
                        ...payload,
                        isLoading: false,
                    },
                },
            };
        }
        case types.FETCH_EXPERIMENT.ERROR: {
            const { payload: { projectId }, } = action;
            return {
                ...state,
                experiments: {
                    ...state.experiments,
                    [projectId]: {
                        isLoading: false,
                    },
                },
            };
        }
        case types.SET_EXPERIMENTS: {
            const { payload: { experiments }, } = action;
            return {
                ...state,
                experiments,
            };
        }
        default:
            return state;
    }
};
export const getReducer = () => ({
    [NAMESPACE]: reducer,
});
//# sourceMappingURL=reducer.js.map